const sliders = document.querySelectorAll('.before-after__slider');

if (sliders) {
  sliders.forEach((slider) => {
    slider.addEventListener('input', function (e) {
      let sliderPos = e.target.value;

      sliderPos = Math.max(11, Math.min(92, sliderPos));

      const container = e.target.closest('.before-after');

      container.querySelector(
        '.before-after__foreground-img'
      ).style.clipPath = `inset(0 ${100 - sliderPos}% 0 0)`;
      container.querySelector(
        '.before-after__slider-button'
      ).style.left = `calc(${sliderPos}% - 13px)`;
    });
  });
}
